import { render, staticRenderFns } from "./UpdateSupplierDialog.vue?vue&type=template&id=888927ba"
import script from "./UpdateSupplierDialog.vue?vue&type=script&lang=js"
export * from "./UpdateSupplierDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports